// Build-time feature flags, set per deployment profile (see .env.canara)
export const HIDE_CREATE_CONSENT =
	process.env.REACT_APP_HIDE_CREATE_CONSENT === 'true';

// Captcha is off unless the profile turns it on.
export const DISABLE_CAPTCHA = process.env.REACT_APP_CAPTCHA_ENABLED !== 'true';
